// Lib
import React from 'react';
import { Formik, Field } from 'formik';

// Components
import CodeEditor from 'components/Fields/CodeEditor';
import { FullHeightForm, ContentContainer } from 'components/SharedStyledElements';
import FormAccordionHelper, { SectionType } from '../../components/AccordionHelper';

interface FormValues {
  htmlCode: string;
}

interface Props {
  rawContent: string;
  onSubmit: (contentString: string) => void;
  formId: string;
  isReadOnly: boolean;
  closePanel: () => void;
}

const HtmlContent = ({ rawContent, onSubmit, formId, isReadOnly, closePanel }: Props) => {
  const initialValues: FormValues = {
    htmlCode: rawContent || '',
  };

  const handleSubmit = ({ htmlCode: contentString }: FormValues) => {
    onSubmit(contentString);
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {() => (
        <FullHeightForm id={formId}>
          <FormAccordionHelper initialValues={initialValues} index={SectionType.Content} closePanel={closePanel} />
          <ContentContainer withPadding>
            <Field tag="text_textarea_content" name="htmlCode" component={CodeEditor} disabled={isReadOnly} />
          </ContentContainer>
        </FullHeightForm>
      )}
    </Formik>
  );
};

export default HtmlContent;
